var module = angular.module('octopusApp.infrastructure')
    .run(function($rootScope) {

        var eventName = 'PageVisibility';

        // Set the name of the hidden property and the change event for visibility
        var hidden, visibilityChange;
        if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }

        function handleVisibilityChange() {
            $rootScope.$broadcast(eventName, {hidden: !!document[hidden]});
        }

        if (typeof document.addEventListener === "undefined" || typeof document[hidden] === "undefined") {
            console.log("This browser does not appear to support the Page Visibility API so some unnecessary requests may still be made while the page is not visible.");
        } else {
            document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }

    });


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/configuration/pageVisibilityBroadcast.js
// module id = 648418567540929
// module chunks = 1